import { render, staticRenderFns } from "./ListLinks.vue?vue&type=template&id=3995dda1"
import script from "./ListLinks.vue?vue&type=script&lang=ts"
export * from "./ListLinks.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports